<script setup>
import CRelatedProductItem from "@/Components/CRelatedProductItem.vue"

const props = defineProps({
    products: Array
})
</script>

<template>
    <v-sheet class="mx-auto" height="40vh">
        <v-row>
            <v-slide-group class="pa-4" show-arrows>
                <v-slide-group-item v-for="product in products" :key="product.id">
                    <c-related-product-item :product=product />
                </v-slide-group-item>
            </v-slide-group>
        </v-row>
    </v-sheet>
</template>
